import whenDomReady from 'when-dom-ready'

const detectAnimationContainers = () =>
  new Promise((resolve, reject) => {
    const containers = document.getElementsByClassName("jsAPAnimation");

    containers.length > 0 ?
      resolve(containers) : reject('No animation containers');
  });

const injectAnimations = async containers => {
  const { default: lottie } = await import(
    /* webpackChunkName: 'async.lottie-web' */ 'lottie-web/build/player/lottie.min.js'
  );

  Array.from(containers).forEach(item => {
    const loop = !!item.dataset.animLoop;
    const animationName = item.dataset.animName;

    const loadAnimation = () => {
      import(/* webpackChunkName: '[request]' */ `./animations/${animationName}.js`)
        .then(({ default: animationData }) => {
          const animation =
            lottie.loadAnimation({
              container: item,
              renderer: "svg",
              loop,
              animationData,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
                className: "Image-animation-content",
              },
            })

          animation.addEventListener('DOMLoaded', () => {
            const imgs = item.querySelectorAll('.Image-animation-placeholder');
            if (imgs.length > 0) { imgs[0].style.opacity = 0 }
          });

          return animation.addEventListener('loaded_images', () =>
            animation.play()
          )
        })
        .catch(e => { throw e })
    };

    const animationObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          //entry.target.classList.add('u-animation-observer-active');
          loadAnimation();
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '1050px',
      threshold: 0.5
    });

    animationObserver.observe(item);
  });
}

whenDomReady()
  .then(detectAnimationContainers)
  .then(injectAnimations)
  .catch(e => e)
